<template>
    <div>
        <div v-if="dashboardStore.ready" @click="announcementModalToggle" class="p-[10px]">
            <div class="flex items-center relative p-[5px] rounded-[5px] [background:var(--marquee-bg)] mobile_marquee_box">
                <div>
                    <Icon iconClass="icon-annoucement w-[20px] h-[20px] marquee-icon-mobile"></Icon>
                </div>
                <div v-if="marqueeList.length > 0" class="marquee_box">
                    <Marquee>
                        <div class="flex items-center">
                            <template v-for="(d, index) in marqueeList" :key="index">
                                <div v-html="d.content"></div>
                                <div v-if="marqueeList.length != (index+1)" class="opacity-0 w-[100vw]" v-html="d.content"></div>
                            </template>
                        </div>
                    </Marquee>
                </div>
                <div v-else class="marquee_box">
                    <Marquee>
                        <div class="flex items-center announcement-text-mobile">
                            <div v-html="$t('no_announcement_at_the_moment')"></div>
                        </div>
                    </Marquee>
                </div>
            </div>
        </div>
        <div v-else class="p-[10px]">
            <div class="flex items-center relative p-[5px] rounded-[5px] [background:var(--marquee-bg)]">
                <Icon iconClass="icon-annoucement w-[20px] h-[20px] marquee-icon-mobile"></Icon>
                <div class="marquee_box"></div>
            </div>
        </div>
        <!-- <div v-if="!dashboardStore.ready" class="p-[10px]">
            <div class="bg-[var(--marquee-bg)] skeleton h-[30px]"></div>
        </div> -->
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const dashboardStore = useDashboardStore();
const mainStore = useMainStore()

const marqueeList = computed(() => {
    if (dashboardStore.ready && dashboardStore.data) {
        var buildArray = [];
        if (dashboardStore.data.announce) {
            for (var i = 0; i < dashboardStore.data.announce.length; i++) {
                buildArray.push(dashboardStore.data.announce[i])
            }
        }
        return buildArray;
    }
    return [];
})

const announcementModalToggle = (e) => {
    var is_popup_flag = "0";
    if (dashboardStore.data.announce) {
        for (let i = 0; i < dashboardStore.data.announce.length; i++) {
            if (dashboardStore.data.announce[i].is_popup == '1') {
                is_popup_flag = "1"
            }
        }
    }

    if (is_popup_flag == "1" || dashboardStore.data.advertisement) {
        mainStore.announcementModal = true;
    }
}
</script>

<style scoped>
.smooth-hide {
    animation: compress 0.6s;
    animation-fill-mode: forwards;
}

.icon-annoucement{
	background: white;
    border-radius: 100%;
    padding: 5px;
    font-size: 12px;
}

.marquee-icon-mobile {
	color: #111111;
}

@keyframes compress {
    0% {
        height: 40px;
    }
    100% {
        height: 8px;
    }
}
</style>